export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11604.2ce38f3b.jpg";